<div class="w-100 d-flex">
    <a [href]="this.getLink()" 
       [class]="'bs-button th-text-main ' + this.getStyleClass()" 
       [target]="(this.getIsNewTab() ? '_blank' : '_self')"
       [ngClass]="{
        'th-text-main': this.getTextColor() === Color.Primary || !this.getTextColor(),
        'th-text-secondary': this.getTextColor() === Color.Secondary,
        'th-text-white': this.getTextColor() === Color.Default || this.getTextColor() === Color.White,
        'th-text-hover-primary': (this.getHoverColor() === Color.Primary || !this.getHoverColor()),
        'th-text-hover-secondary': this.getHoverColor() === Color.Secondary,
        'th-text-hover-white': this.getHoverColor() === Color.White || this.getHoverColor() === Color.Default,
        'th-text-hover-neutral': this.getHoverColor() === Color.Neutral
       }">
       {{this.getText()}}
    </a>
</div>